/**
 * UCWonderLogo — brand mark: the exact route-line "W" + map pin from the
 * supplied logo artwork (recolored light blue, transparent background,
 * served from /public/ucwonder-w-mark.png) + UCWONDER wordmark (navy).
 */
import React from 'react';

const NAVY = '#1E3F70';

export const UCWonderLogo = ({ className = 'h-6', textClass = 'text-xl', ...props }) => (
  <span className="inline-flex items-center gap-2 select-none" {...props}>
    <img
      src="/ucwonder-w-mark.png"
      alt=""
      aria-hidden="true"
      className={`${className} w-auto flex-shrink-0`}
      style={{ filter: 'drop-shadow(0 1px 2px rgba(30, 63, 112, 0.20))' }}
      draggable={false}
    />
    <span
      className={`${textClass} font-extrabold tracking-wide leading-none`}
      style={{ color: NAVY, textShadow: '0 1px 3px rgba(30, 63, 112, 0.15)' }}
    >
      UCWONDER
    </span>
  </span>
);
